import { IQuestion } from "../Question";

export abstract class DataConverter {
    constructor(
        protected rawDataFull: any,
        protected rawDataWithR: any
    ) {
    }
}